// extracted by mini-css-extract-plugin
export default {"base":"Loader_base__CgIRU","spin":"Loader_spin__tG7Tm"};